/**
 * Action name: md_compare
 */

export function compareAndDelete() {
	var data = {
		action: 'md_compare',
		security: md_object.nonce
	};

	jQuery.ajax({
		data: data,
		success: (response) => {
			jQuery('#response').html(response);
		},
		error: (err) => {
			console.log(err);
		}
	});
}
